import { ChevronRight } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const Tabs = ({ activeTab, setActiveTab, tabs = [], loading }) => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [showHint, setShowHint] = useState(false);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    navigate(`/services/${tabId}`);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setShowHint(el.scrollWidth > el.clientWidth);
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [tabs]);

 const scrollToRight = () => {
   if (scrollRef.current) {
     scrollRef.current.scrollBy({
       left: 150, 
       behavior: "smooth",
     });
   }
 };

  if (loading) return null;

  return (
    <div className="relative">
      {/* Scrollable Tabs */}
      <div
        ref={scrollRef}
        className="flex gap-2 md:gap-3 overflow-x-auto no-scrollbar py-3 pr-10"
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`shrink-0 whitespace-nowrap px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border text-xs sm:text-sm transition-all
                ${
                  isActive
                    ? "bg-[#92451E] text-white border-[#92451E]"
                    : "bg-white text-black border-gray-300 hover:bg-white"
                }
              `}
            >
              {tab.name}
            </button>
          );
        })}
      </div>

      {/* Scroll Hint */}
      {showHint && (
        <button
          onClick={scrollToRight}
          className="absolute right-0 top-0 h-full w-10 flex items-center justify-center active:scale-[0.98] bg-gradient-to-l from-brandAccentColor via-brandAccentColor/50 to-transparent "
        >
          <ChevronRight className="w-6 h-8 -mr-4 text-accentTextColor " />
        </button>
      )}
    </div>
  );
};

export default Tabs;
